import {AccountCircle} from '@mui/icons-material';
import {FeatureObject} from '../../../types/FeatureObject';
import {FeatureStatus} from '../../../types/FeatureStatus';
import EtsyAccounts from './EtsyAccounts';

export const etsyAccounts: FeatureObject = {
  type: 'settings',
  title: 'Etsy Accounts',
  description: 'Manage your Etsy accounts',
  IconComponent: AccountCircle,
  path: '/accounts',
  component: () => <EtsyAccounts />,
  status: FeatureStatus.PROD,
};
